import React from "react";
import SecurityControls from "./SecurityControls.js";
import ContractControls from "./ContractControls.js";
import SwipeableViews from "react-swipeable-views";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

class LoanActive extends React.Component {
    state = {
        value: 0
    };

    switchTab = (e, value) => this.setState({ value });

    render() {
        const {
            car,
            client,
            manager,
            userPermissions,
            onAddComment,
            onDeleteComment,
            onContractRepay,
            onContractIncrease
        } = this.props;
        const { value } = this.state;

        const tabs = []
            .concat(
                userPermissions.includes("contract-manager")
                    ? [{ label: "Управление", icon: <PersonAddIcon /> }]
                    : []
            )
            .concat(
                userPermissions.includes("contract-security")
                    ? [{ label: "Безопасность", icon: <ExitToAppIcon /> }]
                    : []
            );

        return (
            <React.Fragment>
                <Tabs value={value} onChange={this.switchTab} centered>
                    {tabs.map((tab, i) => (
                        <Tab key={i} label={tab.label} icon={tab.icon} />
                    ))}
                </Tabs>
                <SwipeableViews axis="x" index={value}>
                    <div dir="x">
                        {value === 0 && (
                            <ContractControls
                                car={car}
                                manager={manager}
                                onAddComment={onAddComment}
                                onDeleteComment={onDeleteComment}
                                onContractIncrease={onContractIncrease}
                                onContractRepay={onContractRepay}
                                userPermissions={userPermissions}
                                client={client}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 1 && (
                            <SecurityControls
                                car={car}
                                onAddComment={onAddComment}
                                userPermissions={userPermissions}
                                onDeleteComment={onDeleteComment}
                            />
                        )}
                    </div>
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default LoanActive;



// WEBPACK FOOTER //
// ./src/components/LoanActive.js